<template>
  <div class="page" @touchmove.prevent>
    <div class="bg-window"></div>
    <div class="main">
      <!-- <div class="title">匹配结果</div> -->
      <img class="pic-title" src="https://static.huiyiji520.com/cppic-1661248653.png">

      <div class="success" v-if="result == 'success'">
        <div class="items">
          <div class="item-outer user-wechat flex-box">
            <!-- 你的微信号：{{user_wechat}} -->
            <img class="pic-hint-uwechat" src="https://static.huiyiji520.com/cppic-1661248670.png">{{user_wechat}}
          </div>
          <div class="item-outer flight flex-box">
            <!-- 机长微信：扫描下方二维码添加机长↓↓ -->
            <img class="pic-hint-flight" src="https://static.huiyiji520.com/cppic-1661248687.png">
          </div>
          <div class="flex-box flight-qrcode">
            <div class="flight-cpcode flex-box">
              <div class="item-inner flight flex-box">
                <!-- 航班号：{{flight}} -->
                <img class="pic-hint-flicode" src="https://static.huiyiji520.com/cppic-1661248966.png">{{flight}}
              </div>
              <div class="item-inner cpcode flex-box">
                <!-- 座位号：{{cpcode}} -->
                <img class="pic-hint-cpcode" src="https://static.huiyiji520.com/cppic-1662545343.png">{{cpcode}}
              </div>
            </div>
            <img class="qrcode" :src="captain">
          </div>
        </div>

        <!-- <div class="hint">请于<span class="deadline">{{deadline}}</span>前添加机长微信↑↑</div> -->
        <!-- <div class="hint">活动开始后，由机长邀请你入群</div> -->
        <!-- <div class="hint">逾期将视为退出活动，不予退款！</div> -->
        <div class="hint flex-box">
          <img class="pic-please" src="https://static.huiyiji520.com/cppic-1661248987.png">
          <span class="deadline">{{$store.state.timeGroup}}</span>
          <img class="pic-addcrew" src="https://static.huiyiji520.com/cppic-1661249001.png">
        </div>
        <div class="hint flex-box">将此页面截图发给机长</div>
        <div class="hint flex-box"><img class="pic-invite" src="https://static.huiyiji520.com/cppic-1661249017.png"></div>
        <div class="hint flex-box"><img class="pic-delay" src="https://static.huiyiji520.com/cppic-1661249032.png"></div>

      </div>

      <div class="fail" v-if="result == 'fail' && level != 'membership'">
        <!-- <div class="interpret">本次匹配失败</div>
        <div class="interpret">未匹配到符合你要求的CP</div>
        <div class="interpret">系统会在<span class="keynote">2022年9月1日</span>前<span class="keynote">自动退款</span></div>
        <div class="interpret">退款金额将原路退回支付账户</div> -->
        <div class="pic-interpret flex-box"><img class="pic-regret" src="https://static.huiyiji520.com/cppic-1661274766.png"></div>
        <div class="pic-interpret flex-box"><img class="pic-nomatch" src="https://static.huiyiji520.com/cppic-1661274808.png"></div>
        <div class="pic-interpret flex-box">
          <img class="pic-system" src="https://static.huiyiji520.com/cppic-1661274826.png">
          <span class="keynote">{{$store.state.timeRefund}}</span>
          <img class="pic-autorefund" src="https://static.huiyiji520.com/cppic-1661274790.png">
        </div>
        <div class="pic-interpret flex-box"><img class="pic-refundway" src="https://static.huiyiji520.com/cppic-1661274851.png"></div>
        <div class="pic-interpret flex-box"><span class="next-welcome">欢迎下期活动继续报名！</span></div>
      </div>

      <div class="fail" v-if="result == 'fail' && level == 'membership'">
        <div class="interpret">本次匹配失败</div>
        <div class="interpret">未匹配到符合你要求的CP</div>
        <div class="interpret">系统将恢复你的可用额度，下期活动仍可使用</div>
      </div>

    </div>
  </div>
</template>

<script>
import { Toast, Dialog } from 'vant'

export default{
  components: {
    [Toast.name]: Toast,
    [Dialog.name]: Dialog
  },
  data(){
    return {
      result: '',
      user_wechat: '',
      captain: '',
      flight: '',
      cpcode: '',
      level: ''
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },
    getMatchResult(){
      let stage = this.$store.state.currentStage
      let timeLookup = this.$store.state.timeLookup
      if(stage == "enrolling" || stage == "matching" || stage == "matched"){
        Dialog.confirm({
          message: `${timeLookup}开放查询本期匹配结果`,
          showConfirmButton: false,
          showCancelButton: false
        })
        .then(() => {
          // on confirm
        })
        .catch(() => {
          // on cancel
        });
      }else if(stage == "lookuping" || stage == "finished"){
        let openid = this.$store.state.userinfo.openid
        let issue = this.$store.state.issue
        let _this = this
        this.$api.get('/couple/get_match_result', {openid: openid, issue: issue}, res => {
          if(res.code == 200){
            if(res.valid == "ok"){
              if(res.match == "success"){
                this.result = "success"
                this.user_wechat = res.userinfo.wechat
                this.captain = res.userinfo.assistant
                this.flight = res.userinfo.flight
                this.cpcode = res.userinfo.cp_code
                this.level = res.level
              }else{
                this.result = "fail"
                this.level = res.level
              }
            }else{
              Toast('你本期没有报名！')
            }
          }
        })
      }
    }
  },
  mounted(){
    this.getMatchResult()
  }
}
</script>

<style scoped>
.page{min-height:100vh;}
.bg-window{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-image: url("https://static.huiyiji520.com/cppic-1661178650.png");
  background-size:100% 100%;
  background-repeat:no-repeat;
  /* opacity:0.1; */
  z-index:-1;
}
.main{text-align:center;}
.main .title{margin-top:200px;margin-bottom:113px;font-size:50px;color:#eb8e80;}
.main .pic-title{width:273px;height:69px;margin:0 auto;margin-top:200px;margin-bottom:138px;}
.main .items{margin-bottom:67px;}
.main .items .item-outer{font-size:30px;background:#E9C5C0;width:80%;margin:0 auto;margin-bottom:68px;height:75px;padding-left:12px;}
.main .items .item-outer .pic-hint-uwechat{width:166px;height:30px;margin-right:20px;}
.main .items .item-outer .pic-hint-flight{width:554px;height:30px;}
.main .items .flight-qrcode{justify-content:space-between;width:80%;margin:0 auto;}
.main .items .flight-cpcode{flex-direction: column;height:220px;justify-content:space-between;}
.main .items .flight-qrcode .item-inner{font-size:30px;background:#E9C5C0;height:75px;padding-left:12px;width:290px;}
/* .main .items .flight-qrcode .item-inner.cpcode{margin-bottom:0px;} */
.main .items .flight-qrcode .pic-hint-flicode{width:103px;height:30px;margin-right:20px;}
.main .items .flight-qrcode .pic-hint-cpcode{width:82px;height:29px;margin-right:40px;}
.main .qrcode{width:220px;}
.main .hint{font-size:30px;margin-bottom:30px;justify-content:center;}
.main .hint .deadline{color:#eb8e80;margin-left:10px;margin-right:10px;font-size:32px;}
.main .hint .pic-please{width:61px;height:30px;}
.main .hint .pic-addcrew{width:217px;height:30px;}
.main .hint .pic-invite{width:436px;height:34px;}
.main .hint .pic-delay{width:448px;height:34px;}
.main .fail{padding-top:24px;}
.main .fail .interpret{font-size:32px;margin-bottom:20px;}
.main .fail .keynote{color:#eb8e80;}
.main .fail .next-welcome{color:#eb8e80;font-size:40px;}
.main .fail .pic-interpret{font-size:36px;margin-bottom:66px;justify-content:center;}
.main .fail .pic-interpret .keynote{color:#eb8e80;}
.main .fail .pic-interpret .pic-regret{width:373px;height:40px;}
.main .fail .pic-interpret .pic-nomatch{width:424px;height:36px;}
.main .fail .pic-interpret .pic-system{width:186px;height:36px;}
.main .fail .pic-interpret .pic-autorefund{width:186px;height:36px;}
.main .fail .pic-interpret .pic-refundway{width:483px;height:36px;}
</style>
